// Name of the variables that will be used in the project. Also used as sort of an ENUM.
import json_config from '../../../consts/contracts_config.json';
export const PROJECTS = json_config;
